<template>
	<section
		class="timer py-10 md:py-20 px-4 md:px-content will-change"
		:data-scroll-section="inner == 'false'"
	>
		<div
			class="flex items-baseline justify-center"
			v-if="blockData.type === 'Time & Weather'"
		>
			<div
				class="flex flex-col flex-grow-0 flex-shrink xl:items-center"
				style="flex-basis: 0%"
				v-show="time"
			>
				<div
					class="font-canela font-light text-navy-blue-01 leading-none text-2xl xl:text-heading mb-[10px] whitespace-nowrap"
				>
					{{ time }}
					<span class="font-ginger tracking-desk text-xs">{{ am_pm }}</span>
				</div>
				<div class="text-navy-blue-03 uppercase tracking-desk text-xs">
					{{ __("Local Time", "ccave") }}
				</div>
			</div>

			<div class="bg-navy-blue-02 mx-5 xl:mx-11 w-1/5 h-[1px]"></div>

			<div
				class="flex flex-col justify-between items-center xl:px-11 mb-14 xl:mb-0 w-1/2 xl:w-auto"
				style="flex-basis: 0%"
				v-show="temperature && weather"
			>
				<div
					class="font-canela font-light text-navy-blue-01 leading-none text-2xl xl:text-heading mb-[10px]"
				>
					{{ temperature }}°C
				</div>
				<div
					class="text-navy-blue-03 uppercase tracking-desk text-xs xl:text-center"
				>
					{{ weather }}
				</div>
			</div>
		</div>
		<div
			v-else
			class="grid custom-xl:grid-cols-6 xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 place-items-center"
			data-scroll
			data-scroll-class="xyz-in"
			xyz="fade down duration-15"
		>
			<template>
				<div
					v-for="(item, index) in blockData.items"
					:key="index"
					class="flex w-full items-center justify-center text-center"
				>
					<div
						class="flex flex-col font-canela justify-between flex-shrink-0 max-w-[300px] w-full min-h-[100px] items-center xl:p-4 lg:mb-14 mb-6 xl:mb-0"
					>
						<count-up-number :value="item.bigger_text" />
						<p
							class="text-navy-blue-01 flex-wrap font-canela max-w-[300px] uppercase tracking-desk text-xs text-center"
							v-html="item.smaller_text"
						></p>
					</div>

					<!-- equal line separator -->
					<div
						v-if="index !== blockData.items.length - 1"
						class="hidden custom-xl:block bg-navy-blue-02 flex-1 h-[1px]"
					></div>
				</div>
			</template>
		</div>
	</section>
</template>

<script>
import { format, parseISO } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
export default {
	name: "InfoBar",
	data() {
		return {
			time: false,
			am_pm: false,
			temperature: false,
			weather: false,
			lon: 42.3957,
			lat: 18.6294,
			appid: "4a0833de3006e68783c560455132c0e2",
			weatherUnits: "metric",
		};
	},
	mounted() {
		this.getWeather();
		setInterval(() => {
			this.time = this.formatTime();
		}, 1000);
		this.am_pm = this.formatAMPM();
	},
	methods: {
		getDateTime() {
			const today = new Date();
			const timeZone = "Europe/Montenegro";
			/*      const utcDate = zonedTimeToUtc(today, timeZone) */
			const montenegroDateTime = format(today, "yyyy-MM-dd HH:mm:ss", {
				timeZone,
			});
			return montenegroDateTime;
		},
		formatTime() {
			let date = this.getDateTime();
			let formated = format(parseISO(date), "hh:mm");
			return formated;
		},
		formatAMPM() {
			let date = this.getDateTime();
			let formated = format(parseISO(date), "a");
			return formated;
		},
		getWeather() {
			var url_params = {
				lon: this.lon,
				lat: this.lat,
				appid: this.appid,
				units: this.weatherUnits,
			};
			var searchParams = new URLSearchParams(url_params);
			this.$http
				.get("https://api.openweathermap.org/data/2.5/weather?" + searchParams)
				.then((res) => {
					this.temperature = Math.floor(res.data.main.temp);
					this.weather = res.data.weather[0].description;
				});
		},
	},
};
</script>
